import useDBO, { Usedbo } from "../../hooks/useDBO.ts";
import Loading from "../../components/Loading.jsx";
import Error from "../../components/Error.jsx";
import { Lesson } from "./types.ts"
import EditSyllabusButton from "../../components/EditSyllabusButton.tsx";
import IconButtonHT from "../../components/IconButtonHT.tsx";
import mut from "../../hooks/mut.ts";
import HtTabs from "../../components/HtTabs.jsx";
import edate from "../../../../sdate.ts";

export default function Materials() {


const lessons = useDBO<Lesson>(`/material-requests`,30);


if (lessons.loading) return <Loading />;
if (lessons.error) return <Error />;


    lessons.log();

    const pending = lessons.filter(l => !l.materialRequestsCompleted)
    const completed = lessons.filter(l=>!!l.materialRequestsCompleted)
    
    const components = [
        <div>{pending.map(l => <Request lesson={l} lessons={lessons} />)}</div>,
        <div>{completed.map(l => <Request lesson={l} lessons={lessons} />)}</div>]


    return (<div>
        <HtTabs labels={[`Pending (${pending.length})`,`Completed (${completed.length})`]} components={components} />  
</div>)
}

type RequestProps = {
    lesson: Lesson
    lessons: Usedbo<Lesson>
}

function Request({ lesson, lessons }: RequestProps) {
    
    const handleUpdate = async () => {
        let url = lesson.materialRequestsCompleted ? `/pending-materials/${lesson._id}` : `/complete-materials/${lesson._id}`
        let res = await mut(url, {});
        if (lesson.materialRequestsCompleted) {
          lessons.update(res);  
        } else {
          lessons.replace(res)
        }
    }
    
    return (
      <div className="flex justify-between">
        <div>
          <div className="font-bold">
            {lesson.name}, {new edate(lesson.tDate).fDate()} {lesson.startTime}
          </div>
          <div className="text-sm">{lesson.materialRequests}</div>
        </div>
        <div className="flex gap-3">
          {lesson.lessonOrTest.type === "lesson" ? (
            <EditSyllabusButton
              syllabus={lesson.syllabus}
              unit={lesson.lessonOrTest.lesson.unit._id}
              lesson={lesson.lessonOrTest.lesson._id}
            />
          ) : (
            <EditSyllabusButton
              syllabus={lesson.syllabus}
              unit={lesson.lessonOrTest.lesson.unit._id}
            />
          )}
          {lesson.materialRequestsCompleted ? (
            <div>
              <IconButtonHT
                icon="x"
                onClick={handleUpdate}
                color="red"
              />{" "}
            Back to pending
            </div>
          ) : (
            <div>
              <IconButtonHT
                icon="tick"
                onClick={handleUpdate}
                color="green"
              />{" "}
              Completed
            </div>
          )}
        </div>
      </div>
    );
}